import { create } from 'zustand';
import { applyNodeChanges, applyEdgeChanges, addEdge } from 'reactflow';

// ==================== FLOWCHART STORE ====================
const useFlowchartStore = create((set, get) => ({
  // Core data
  nodes: [],
  edges: [],
  
  // Metadata
  title: '',
  owner: false,
  
  // ==================== NODE OPERATIONS ====================
  
  onNodesChange: (changes) => {
    set({ nodes: applyNodeChanges(changes, get().nodes) });
  },

  updateNodeLabel: (nodeId, label) => {
    set({
      nodes: get().nodes.map((node) =>
        node.id === nodeId
          ? { ...node, data: { ...node.data, label } }
          : node
      ),
    });
  },

  setNodes: (nodes) => set({ nodes }),

  // ==================== EDGE OPERATIONS ====================

  onEdgesChange: (changes) => {
    set({ edges: applyEdgeChanges(changes, get().edges) });
  },

  onConnect: (connection) => {
    set({
      edges: addEdge(
        {
          ...connection,
          id: `edge-${connection.source}-${connection.target}-${Date.now()}`,
          type: 'smoothstep',
        },
        get().edges
      ),
    });
  },

  setEdges: (edges) => set({ edges }),

  // ==================== METADATA ====================

  setTitle: (title) => set({ title }),
  setOwner: (owner) => set({ owner }),
}));

export default useFlowchartStore;